import {useEffect, useState} from 'react';
import {
    assignLicense,
    assignUserToGroup,
    createOrUpdateUserGroup, getAssignmentsPerLicense,
    getLicensesList,
    getLicensingUserGroupList,
    getUsersList
} from "./utils/licensing";
import {useDebounce} from "./useDebounce";
import {slugify} from "./helpers";  // Replace with the correct path

const useAssignmentsPerLicense = ({platformType="user", isGroup=false, license, refresh=null}) => {

    const [assignments, setAssignments] = useState([])
    const [loading, setLoading] = useState(false)

    const handleFetchSuccess = (data) => {
        if(Array.isArray(data?.results)){
            setAssignments(data?.results)
        }
        setLoading(false)
    }

    const unAssignLicense = ({assignment, isGroup, handleUnAssignmentCallback}) => {
        assignLicense(platformType, {assignment_id:assignment?.id}, handleUnAssignmentCallback, isGroup, true)
    }

    useDebounce(()=>{
        setLoading(true)
        getAssignmentsPerLicense({license_id:license?.id}, platformType, handleFetchSuccess, ()=>{}, isGroup )
    }, 200, [isGroup, refresh])

    return {
        assignments,
        loading,
        unAssignLicense
    }


};

export default useAssignmentsPerLicense;
